import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import ConfirmableButton from '@/components/ConfirmableButton.vue';
import ModalMixin from '@/mixins/modal-mixin';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters, mapState } from 'vuex';
let NotesComponent = class NotesComponent extends Mixins(ModalMixin) {
    customerId;
    tooth;
    findNotesInStore;
    fetchNotes;
    removeNote;
    createNote;
    isNoteCreatePending;
    text = '';
    error = null;
    get notes() {
        return this.findNotesInStore(this.params).data;
    }
    get params() {
        const params = {
            query: {
                customerId: this.customerId,
                $sort: { updatedAt: -1 }
            }
        };
        if (this.tooth > 0)
            params.query.tooth = this.tooth;
        return params;
    }
    created() {
        this.fetchNotes(this.params);
    }
    noteBody(item) {
        return this.$n2br(item.text);
    }
    noteUpdateTime(note) {
        return this.$moment(note.updatedAt).format('LLL');
    }
    deleteNote(item) {
        this.removeNote(item._id).then(() => {
            this.$toasted.global.success({
                message: this.$t('Note has been deleted')
            });
        });
    }
    createNewNote() {
        if (this.isNoteCreatePending)
            return;
        this.error = null;
        this.createNote({ text: this.text, customerId: this.customerId, tooth: this.tooth }).then(() => {
            this.text = '';
        }).catch(error => {
            this.error = error;
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], NotesComponent.prototype, "customerId", void 0);
__decorate([
    Prop({ type: Number })
], NotesComponent.prototype, "tooth", void 0);
NotesComponent = __decorate([
    Component({
        name: 'notes',
        components: {
            Avatar,
            ConfirmableButton,
        },
        computed: {
            ...mapGetters('notes', { findNotesInStore: 'find' }),
            ...mapState('notes', { isNoteCreatePending: 'isCreatePending' }),
        },
        methods: {
            ...mapActions('notes', { fetchNotes: 'find', removeNote: 'remove', createNote: 'create' }),
        },
    })
], NotesComponent);
export default NotesComponent;
